import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateExchangeSettingsDetails } from "../redux/slices";
import { exchangeSettingsActionTypes } from "../redux/utils";
import { usePathNameContext } from "../contexts";
import { htmlColorArr } from "../Utilities";
import { arrayEquals } from "../Utilities/isArrayEqual";
import { capitalizeFirstLetter } from "../Utilities/capitalizeFirstLetter";

/* 
 TODO:Update the variable Name
   Here 
   Color => Variant_1 or Options 1
   Size => Variant_2 or Options 2
   Others => Variant_3 or Options 3
*/

export const useExchangeFetchOther = () => {
  const [colorID, setColorID] = useState(0);
  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedOthers, setSelectedOthers] = useState("");
  const [variantInStock, setVariantInStock] = useState(0);
  const [sizeID, setSizeID] = useState(0);
  const [otherID, setOtherID] = useState(0);
  const [productMainView, setProductMainView] = useState();
  const [productSideView, setProductSideView] = useState([]);
  const [colors, setColors] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [variations, setVariations] = useState([]);
  const [itemToBeReturnedTags, setItemToBeReturnedTags] = useState();
  const [isExLoader, setIsExLoader] = useState(false);
  const [otherOptions, setOtherOptions] = useState([]);
  const [others, setOthers] = useState([]);
  const [otherLabel, setOtherLabel] = useState("");
  const [noVariantAvailable, setNoVariantAvailable] = useState(false);
  const [disableContinueButton, setDisableContinueButton] = useState(false);
  const { pathURL } = usePathNameContext();
  const [variantQty, setVariantQty] = useState([]);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const [isActiveSquare, setIsActiveSquare] = useState(false);

  const dispatch = useDispatch();
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);

  const distinct = (value, index, self) => {
    return self.indexOf(value) === index;
  };

  const response = exchangeSettingsState.selectedOtherVariationObject;

  const response_exchange = exchangeSettingsState.orderExchangeInfo;

  useEffect(() => {
    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_IS_EXCHANGE_OTHER,
        value: true,
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_VARIANT_ID,
        value: response?.variants[0]?.variant_id,
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_PRODUCT_ID,
        value: response?.product_id,
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_VARIATIONS,
        value: response?.variants?.[0],
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_ALLOW_OUT_OF_STOCK,
        value: response_exchange.data.allow_out_of_stock,
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_SELECTED_PRODUCT_NAME_OTHER,
        value: response.name,
      })
    );

    if (
      response?.options.length === 1 &&
      response?.options[0]?.name === "Title" &&
      response?.options[0]?.values.length === 1 &&
      response.options[0]?.values[0] ===
        "Default Title" /* remove this if it is not in use */
    ) {
      setNoVariantAvailable(true);
    }

    let variation_color = [],
      variation_size = [],
      variation_other_tag = [],
      variation_product_main_view = [],
      variation_product_side_view = [];

    response?.variants?.map((variant) => {
      variation_color = [...variation_color, variant.tags[0]].filter(distinct);
      variation_size = [...variation_size, variant.tags[1]].filter(distinct);
      variation_other_tag = [...variation_other_tag, variant.tags[2]].filter(
        distinct
      );
      variation_product_main_view = [
        ...variation_product_main_view,
        variant.img_url,
      ];
      variation_product_side_view = [
        ...variation_product_main_view,
        variant.img_url,
      ];

      setSizes(variation_size.filter((el) => el != null && el !== ""));
      setColors(variation_color.filter((el) => el != null && el !== ""));
      setOthers(variation_other_tag.filter((el) => el != null && el !== ""));

      // setColors(response.options[0]?.values);
      // setSizes(response.options[1]?.values);
      // setOthers(response.options[2]?.values);

      setProductMainView(variation_product_main_view);
      setProductSideView(variation_product_side_view);
      setVariations(response?.variants);
      variation_color?.map((item) => {
        let tempArr = htmlColorArr();
        if (!tempArr?.includes(item?.toLowerCase())) {
          setIsActiveSquare(true);
        }
      });

      response?.options?.map((item) => {
        if (
          item.name !== "Size" &&
          item.name !== "Color" &&
          item.name !== "Title"
        ) {
          setOtherLabel(item.name);
        }
      });
    });
    let labels;

    labels = response?.options?.map((item, index) => {
      return item.name + ":";
    });
    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_VARIANTS_LABELS,
        value: labels,
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
        value: response?.name,
      })
    );

    // setSelectedColor(response?.variants[0]?.color);
    // setSelectedSize(response?.variants[0]?.size);
    // setSelectedOthers(response?.variants[0]?.other_tag);
    setSelectedColor(response?.options[0]?.values[0]);
    setSelectedSize(response?.options[1]?.values[0]);
    setSelectedOthers(response?.options[2]?.values[0]);

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_SELECTED_COLOR,
        value: response?.variants[0]?.tags[0],
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_SELECTED_SIZE,
        value: response?.variants[0]?.tags[1],
      })
    );

    dispatch(
      updateExchangeSettingsDetails({
        key: exchangeSettingsActionTypes.UPDATE_SELECTED_OTHER,
        value: response?.variants[0]?.tags[2],
      })
    );

    setProductMainView(response?.variants[0]?.images[0]);

    setProductSideView(response?.variants[0]?.images[0]);
  }, []);

  useEffect(() => {
    if (pathURL.toLowerCase() === "/exchangewithotheritems") {
      const selectedItemTags = [
        capitalizeFirstLetter(selectedColor),
        selectedSize,
        selectedOthers,
      ];
      const filterSelectedItemTags = selectedItemTags.filter((a) => a);
      const filteredItem = variations.find((item) => {
        let itemTagsArr = [...item.tags];
        let isTagMatch = arrayEquals(itemTagsArr, filterSelectedItemTags);
        if (isTagMatch) {
          return true;
        }
      });
      if (filteredItem) {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_VARIATIONS,
            value: filteredItem,
          })
        );
      }

      const updateSelectedVariantItemData = (item) => {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE,
            value: item.price,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_PRICE_CURRENCY,
            value: item.currency,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_IMAGE,
            value: item.img_url,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_SIZE,
            value: item.size,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_COLOR,
            value: item.color,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
            value: item.other_tag,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_NAME,
            value: response.name,
          })
        );

        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_VARIANT_ID,
            value: item.variant_id,
          })
        );

        // dispatch(
        //   updateExchangeSettingsDetails({
        //     key: exchangeSettingsActionTypes.UPDATE_EXCHANGE_PRODUCT_ID,
        //     value: item.product_id,
        //   })
        // );

        setProductSideView(item.images);
        // setProductMainView(item.img_url);
      };

      // If Selected Size, Color and Other Tag variant exists
      // If not exist, It automatically re-rendered with size and color that exists
      if (filteredItem) {
        updateSelectedVariantItemData(filteredItem);

        // setDisableContinueButton
        if (
          filteredItem.quantity <= 0 &&
          !exchangeSettingsState.allowOutOfStock
        ) {
          setDisableContinueButton(true);
        } else setDisableContinueButton(false);
      }

      /* setting up size and other variants when user click on the variants */
      let variation_size = [],
        variation_other_tag = [],
        isInStock = false;

      variations?.map((item) => {
        if (
          item?.color.toLowerCase() === selectedColor?.toLowerCase() &&
          item?.size === selectedSize
        ) {
          return (
            (isInStock = true),
            (variation_other_tag = [
              ...variation_other_tag,
              item.other_tag,
            ].filter(distinct))
          );
        }
      });

      variations?.map((item) => {
        if (
          item?.color?.toLowerCase() === selectedColor?.toLowerCase() &&
          item?.size === selectedSize
        ) {
          return (variation_other_tag = [
            ...variation_other_tag,
            item?.other_tag,
          ].filter(distinct));
        }
      });

      // if (variation_other_tag.length === 0) {
      //   isInStock = false;
      //   setSelectedSize(response?.variants[0]?.size);

      //   dispatch(
      //     updateExchangeSettingsDetails({
      //       key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_SIZE,
      //       value: variation_size[0],
      //     })
      //   );

      //   setSizeID((prev) => 0);

      //   setOtherID(0);

      //   setSelectedOthers(variation_other_tag[0]);
      // }

      if (isInStock) {
        setIsOutOfStock(false);
      } else {
        setIsOutOfStock(true);
      }
      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
          value: variation_other_tag[0],
        })
      );
      if (!selectedOthers) {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
            value: variation_other_tag[0],
          })
        );
      } else {
        dispatch(
          updateExchangeSettingsDetails({
            key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_OTHER_TAG,
            value: selectedOthers,
          })
        );
      }

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_COLOR,
          value: selectedColor,
        })
      );

      dispatch(
        updateExchangeSettingsDetails({
          key: exchangeSettingsActionTypes.UPDATE_NEW_ITEM_SIZE,
          value: selectedSize,
        })
      );

      // setSizes(variation_size);
      // setOthers(variation_other_tag);
    }
  }, [
    selectedColor,
    selectedSize,
    selectedOthers,
    pathURL,
    variations,
    exchangeSettingsState.isCustomItem,
    exchangeSettingsState.allowOutOfStock,
    dispatch,
  ]);

  return {
    colors,
    setColorID,
    setSelectedColor,
    colorID,
    sizes,
    setSizeID,
    setSelectedSize,
    sizeID,
    productSideView,
    productMainView,
    itemToBeReturnedTags,
    isExLoader,
    setIsExLoader,
    otherOptions,
    others,
    setOthers,
    otherLabel,
    noVariantAvailable,
    selectedOthers,
    setSelectedOthers,
    otherID,
    setOtherID,
    setProductMainView,
    setProductSideView,
    setSizes,
    setColors,
    variantInStock,
    setVariantInStock,
    variantQty,
    setVariantQty,
    isOutOfStock,
    disableContinueButton,
    isActiveSquare,
  };
};
